import type { ChipOption } from 'client/js/main/screens/ScreenRoiHub/types';

export const FILE_INGESTORS_CHIP: ChipOption = { id: 'chip-file-ingestors', label: 'File ingestors' };

export const CHIPS_SELECTION_OPTIONS: ChipOption[] = [
  FILE_INGESTORS_CHIP,
  { id: 'chip-ingestion-history', label: 'Ingestion history' },
  { id: 'chip-file-templates', label: 'File templates' },
];
